(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const attached = new WeakSet();
  const scan = () => document.querySelectorAll('[data-luma-cta]').forEach(button => {
    if (attached.has(button)) return;
    attached.add(button);
    let visible = false;
    let timer;
    let offTimer;
    const reference = document.querySelector('.luma-hero-cta__cta') || button;
    const style = getComputedStyle(reference);
    ['duration','blur','spread','opacity'].forEach(name => {
      const value = style.getPropertyValue(`--hero-cta-button-glow-${name}`).trim();
      if (value) button.style.setProperty(`--luma-cta-glow-${name}`, value);
    });
    const stop = () => { clearTimeout(timer); clearTimeout(offTimer); button.classList.remove('is-glowing'); };
    const pulse = () => {
      if (!visible || document.hidden || motion.matches || !button.isConnected || reference.dataset.glowEnabled === 'false') return;
      const min = Number(reference.dataset.glowMin || 3) * 1000;
      const max = Math.max(min, Number(reference.dataset.glowMax || 10) * 1000);
      const duration = parseFloat(button.style.getPropertyValue('--luma-cta-glow-duration') || '3') * 1000;
      timer = setTimeout(() => {
        button.classList.add('is-glowing');
        offTimer = setTimeout(() => { button.classList.remove('is-glowing'); pulse(); }, duration);
      }, min + Math.random() * (max - min));
    };
    const sync = () => { stop(); pulse(); };
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }).observe(button);
    else { visible = true; sync(); }
    motion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
  });
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
